import { defineMessages } from 'react-intl';

export default defineMessages({
    personalAuto_EAQuote: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.eu.Auto Insurance Quote',
        defaultMessage: 'Auto Insurance Quote'
    },
    location: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.eu.Location',
        defaultMessage: 'Location'
    },
    vehicles: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.eu.Vehicles',
        defaultMessage: 'Vehicles'
    },
    drivers: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.eu.Drivers',
        defaultMessage: 'Drivers'
    }
});
